import React from "react";

function TemplateIcon() {
  return (
    <div>
      <svg
        viewBox="0 0 24 24"
        fill="white"
        height="20px"
        width="20px"
        // fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 3V9H21V3H3ZM19 5H5V7H19V5Z"
            fill="white"
          ></path>{" "}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 11V21H11V11H3ZM9 13H5V19H9V13Z"
            fill="white"
          ></path>{" "}
          <path d="M21 11H13V13H21V11Z"  fill="white"></path>{" "}
          <path d="M13 15H21V17H13V15Z"  fill="white"></path>{" "}
          <path d="M21 19H13V21H21V19Z"  fill="white"></path>{" "}
        </g>
      </svg>
    </div>
  );
}

export default TemplateIcon;
